var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [(_vm.displayMsg == 'success') ? _c('b-alert', {
    staticClass: "success-display-none",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.displayMsg == 'error') ? _c('b-alert', {
    staticClass: "danger-display-none",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "off",
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('productLogReport.logFor')))])]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.logtype),
      expression: "logtype"
    }],
    staticClass: "col-lg-1 margin10",
    attrs: {
      "type": "radio",
      "name": "logtype",
      "value": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.logtype, "product")
    },
    on: {
      "click": function($event) {
        _vm.updatevalue('product')
      },
      "__c": function($event) {
        _vm.logtype = "product"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "margin6",
    attrs: {
      "for": "productid"
    }
  }, [_vm._v(_vm._s(_vm.$t('productLogReport.product')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.logtype),
      expression: "logtype"
    }],
    staticClass: "col-lg-1 margin10",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "radio",
      "name": "logtype",
      "value": "rack"
    },
    domProps: {
      "checked": _vm._q(_vm.logtype, "rack")
    },
    on: {
      "click": function($event) {
        _vm.updatevalue('rack')
      },
      "__c": function($event) {
        _vm.logtype = "rack"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "margin6",
    attrs: {
      "for": "rackid"
    }
  }, [_vm._v(_vm._s(_vm.$t('productLogReport.rack')))])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.logtype == 'product') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productID')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productIdPlaceHolder'),
      "id": "productid",
      "name": "productid",
      "value": _vm.productid
    },
    model: {
      value: (_vm.productid),
      callback: function($$v) {
        _vm.productid = $$v
      },
      expression: "productid"
    }
  })], 1), _vm._v(" "), (_vm.productid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.productidErr))]) : _vm._e(), _vm._v(" "), (_vm.productidcheck == 1) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.productidError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.logtype == 'rack') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.rackID')) + "  ")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cubes'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "rackid",
      "value": _vm.rackid,
      "type": "text",
      "placeholder": _vm.$t('warehouseRacks.rackIdPlaceHolder'),
      "name": "rackid"
    },
    model: {
      value: (_vm.rackid),
      callback: function($$v) {
        _vm.rackid = $$v
      },
      expression: "rackid"
    }
  })], 1), _vm._v(" "), (_vm.rackid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.rackidErr))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('srmaster.table.clientProductID')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-product-hunt'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('clientproductid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.clientProductIdPlaceHolder'),
      "name": "clientproductid"
    },
    model: {
      value: (_vm.clientproductid),
      callback: function($$v) {
        _vm.clientproductid = $$v
      },
      expression: "clientproductid"
    }
  })], 1), _vm._v(" "), (_vm.clientproductidcheck == 1) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.clientproductidErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('productLogReport.transactionType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Transactiontype),
      expression: "Transactiontype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Transactiontype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Transactiontype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('productLogReport.transactionTypePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.transactiontypeArr), function(warehouse_obj) {
    return _c('option', {
      domProps: {
        "value": warehouse_obj.transactiontype
      }
    }, [_vm._v(_vm._s(warehouse_obj.transactiontype))])
  })], 2)]), _vm._v(" "), (_vm.Transactiontype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.Transactiontype))]) : _vm._e()], 1), _vm._v(" "), (_vm.logtype == 'product' && (_vm.Transactiontype == 'Stock Correction' || _vm.Transactiontype == 'rackid+' || _vm.Transactiontype == 'rackid-')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('productLogReport.virtualTransaction')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.virtualTransaction),
      expression: "virtualTransaction"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "virtualTransaction"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.virtualTransaction = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('productLogReport.virtualTransactionPlaceholder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VAccept"
    }
  }, [_vm._v(_vm._s(_vm.$t('productLogReport.vAccept')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VReject"
    }
  }, [_vm._v(_vm._s(_vm.$t('productLogReport.vReject')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Both"
    }
  }, [_vm._v(_vm._s(_vm.$t('productLogReport.both')))])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('productLogReport.transactionReference')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productLogReport.transactionReference')
    },
    model: {
      value: (_vm.transactionReference),
      callback: function($$v) {
        _vm.transactionReference = $$v
      },
      expression: "transactionReference"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.productLogListing
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.auditLogSerachReset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3  col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('productLogReport.productRackLog')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-4 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), (_vm.download && _vm.productlogData.length > 0) ? _c('div', {
    staticClass: "col-md-2 col-8"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.productlogData.length > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getProductLogListing(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.productlogData.length > 0) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    attrs: {
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-2 cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('receivedEmail.dateandTime')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('productLogReport.user')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.rackID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('daywiseatpstock.currentstock')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.rackStock')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.mrp')))])]), _vm._v(" "), (_vm.activemrpflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.activemrp')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('productLogReport.transactionType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('productLogReport.transactionReference')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.rackType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.totalCurrentStock')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.totalRackStock')))])])])]), _vm._v(" "), _c('tbody', [(_vm.client == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('productLogReport.logNotFoundHeading')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('productLogReport.logNotFoundwithFilters')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.productlogData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.createddatetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.txnuser))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.txnqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.whcurrentstock))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.whrackstock))]), _vm._v(" "), (data.mrp > 0) ? _c('td', [_vm._v(" " + _vm._s(data.mrp) + " ")]) : _c('td', [_vm._v(" 0 ")]), _vm._v(" "), (_vm.activemrpflag) ? _c('td', [_vm._v(_vm._s(data.activemrp))]) : _vm._e(), _vm._v(" "), (data.transactiontype == 'rackid+') ? _c('td', [_vm._v(" " + _vm._s(_vm.$t('config.audit')) + " ++ ")]) : (data.transactiontype == 'rackid-') ? _c('td', [_vm._v(" " + _vm._s(_vm.$t('config.audit')) + " -- ")]) : _c('td', [_vm._v(" " + _vm._s(data.transactiontype) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.txnsource) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.racktype) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalcurrentstock) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalrackstock) + " ")])])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.productlogData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Product Audit Log"
    },
    model: {
      value: (_vm.showAuditDetails),
      callback: function($$v) {
        _vm.showAuditDetails = $$v
      },
      expression: "showAuditDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "height": "75px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.$t('common.rackID')) + ":"), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(" " + _vm._s(_vm.currentAuditData.rackid))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.$t('auditReport.startDate')) + ": "), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.currentAuditData.starttime)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.$t('auditReport.auditBy')) + ": "), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.currentAuditData.userid) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.$t('auditReport.endDate')) + ":"), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("moment")(_vm.currentAuditData.endtime)))])])])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showAuditDetails = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('srmaster.table.productID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('auditReport.systemQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('auditReport.matchQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('auditReport.scannedQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.excessQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('auditReport.excessProductQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shortQty')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.AuditSessionData), function(allocation) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(allocation.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(allocation.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(allocation.systemqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(allocation.matchedqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(allocation.scannedqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(allocation.excessqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(allocation.excessproduct))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(allocation.shortqty))])])
  }), _vm._v(" "), (_vm.AuditSessionData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])])])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-91a1c450", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91a1c450","hasScoped":true}!./src/views/components/reports/productlogreport/productlogreport.component.html
// module id = 1725
// module chunks = 0